function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mirror"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 5",
  width: 20,
  height: 20,
  fill: "#C4C4C4",
  fillOpacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 125",
  d: "M3.75 8.75C3.75 5.29822 6.54822 2.5 10 2.5V2.5C13.4518 2.5 16.25 5.29822 16.25 8.75V16.7703C16.25 17.8637 15.3637 18.75 14.2703 18.75H5.7297C4.63634 18.75 3.75 17.8637 3.75 16.7703V8.75Z",
  fill: "white"
}));

var SvgMirrorLogo = function SvgMirrorLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMirrorLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mirror_logo.90d0b930.svg";
export { ForwardRef as ReactComponent };